import MapElementProps from "../MapElementProps";
import {useAppSelector} from "../../../redux/hooks";
import {useEffect, useState} from "react";
import {GeoJSONSource} from "mapbox-gl";
import {selectMapStyle} from "../../../redux/features/map/slice";
import useInterval from "../../../helpers/useInterval";

export interface MapLayerProps extends MapElementProps {
    data: GeoJSON.Feature<GeoJSON.Geometry> | GeoJSON.FeatureCollection<GeoJSON.Geometry> | undefined;
    layer: mapboxgl.AnyLayer;
    sourceId?: string;
}

const GeoJsonLayer = ({map, data, layer, sourceId}: MapLayerProps) => {
    const [dirty, setDirty] = useState(true);

    useInterval(() => {
        if (dirty) {
            setDirty(false);
            do_draw_layer();
        }
    }, 100);
    
    const do_draw_layer = () => {
        // Use isStyleLoaded() instead of loaded(). loaded() returns false while any
        // Mapbox vector tile source is still fetching (can take 30-100 s at zoom 12
        // over the CDN), which would block addSource/addLayer/setData forever.
        // isStyleLoaded() is true as soon as style JSON + sprites + glyphs are ready
        // (~1-3 s), which is all we need for managing GeoJSON sources and layers.
        if (!map || !map.isStyleLoaded()) {
            setDirty(true);
            return;
        }


        const source_name = sourceId ?? `${layer.id}_source`;
        (layer as any).source = source_name;

        // console.log('do draw', ((data as GeoJSON.Feature<GeoJSON.Geometry>).geometry as GeoJSON.MultiLineString).coordinates.length);
        if (data) {
            // switch (data.type) {
            //     case "Feature":
            //         console.log(layer.id, 'Feature', data.geometry);
            //         break;
            //     case "FeatureCollection":
            //         console.log(layer.id, 'FeatureCollection', data.features);
            //         break;
            // }
            const source: GeoJSONSource = map.getSource(source_name) as GeoJSONSource;
            if (source === undefined) {
                map.addSource(source_name, {
                    type: 'geojson',
                    data: data
                });
                map.addLayer(layer);
            } else {
                source.setData(data);
                // When multiple layers share a sourceId, the source may already
                // exist while this layer hasn't been added yet.
                if (!map.getLayer(layer.id)) {
                    map.addLayer(layer);
                }
            }
        } else {
            console.log(layer.id, 'no data', data);
        }
    };

    useEffect(() => setDirty(true), [])
    const mapStyle = useAppSelector(selectMapStyle);
    useEffect(() => setDirty(true), [mapStyle])
    useEffect(() => setDirty(true), [data])

    return (<></>);
}

export default GeoJsonLayer;